/**
 * Shared unit-identifier cell: a primary catalog-consistent identifier with
 * an optional secondary line (typically the raw supplier number). Used by
 * the units tab, pricing tab, and availability grid row header so all three
 * offer tabs render identifiers under ONE shared presentational policy.
 *
 * The secondary line is rendered only when it is both non-null AND different
 * from the primary — avoids showing the same identifier twice (e.g. a unit
 * whose supplierNumber happens to equal its catalog-consistent identifier).
 */
export interface UnitIdentifierCellProps {
  primary: string;
  secondary?: string | null;
  testIdPrefix: string;
}

export function UnitIdentifierCell({ primary, secondary, testIdPrefix }: UnitIdentifierCellProps) {
  const showSecondary = secondary != null && secondary !== primary;

  return (
    <div className="min-w-0">
      <div
        className="text-xs font-medium font-mono truncate"
        data-testid={`${testIdPrefix}-primary`}
        title={primary}
      >
        {primary}
      </div>
      {showSecondary ? (
        <div
          className="text-xs text-muted-foreground font-mono truncate"
          data-testid={`${testIdPrefix}-secondary`}
          title={secondary}
        >
          {secondary}
        </div>
      ) : null}
    </div>
  );
}
